import React, {Component} from "react";
import { Typography, Grid } from '@material-ui/core';

class Garis extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    

    render() { 
        const {data} = this.props;
        return (
            <hr style={{border: 'solid #BDBDBD 1px', float: 'left' ,width: !this.props.lebar? '100%' : this.props.lebar+'px', marginBottom: 0,marginTop: !this.props.marginTop? '0' : this.props.marginTop+'px'}} />
        );
    }
}
 
export default Garis;